import { Oswald, Roboto_Condensed } from 'next/font/google'

const oswald = Oswald({ weight: ['400', '500'], subsets: ['latin'] })
const roboto = Roboto_Condensed({ weight: ['400', '700'], subsets: ['latin'] })

export type ThemeProps = Partial<{
  fluid: boolean
}>

// eslint-disable-next-line no-unused-vars
const Theme = ({ fluid = true }: ThemeProps) => {
  return (
    <style jsx global>{`
      :root {
        --font-family-oswald: ${oswald.style.fontFamily};
        --font-family-roboto: ${roboto.style.fontFamily};

        --font-size: ${fluid
          ? `clamp(10px, ${(10 / 1440) * 100}vw, 12px)`
          : `10px`};

        --header-height: 8rem;
        --header-height-contained: 8rem;
      }

      @media (min-width: 768px) {
        :root {
          --header-height: 17rem;
          --header-height-contained: 12rem;
        }
      }
    `}</style>
  )
}

export default Theme
